var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var FileUploadDownloadService = /** @class */ (function (_super) {
            __extends(FileUploadDownloadService, _super);
            function FileUploadDownloadService($http, $q, $timeout, upload) {
                var _this = _super.call(this, $http) || this;
                _this.errorMsg = "The file upload was unsuccessful";
                _this.$q = $q;
                _this.$timeout = $timeout;
                _this.upload = upload;
                return _this;
            }
            FileUploadDownloadService.prototype.uploadFiles = function (files, model) {
                var url = "./api/document";
                return this.commonUpload(files, model, url);
            };
            FileUploadDownloadService.prototype.uploadProcessLevelStaticFiles = function (files, model) {
                var url = './api/document/processConfiguration/' + model.processConfigId;
                return this.commonUpload(files, model, url);
            };
            FileUploadDownloadService.prototype.uploadSystemLevelStaticFiles = function (files, model) {
                var url = './api/document/systemLevel/' + model.systemLevelId;
                return this.commonUpload(files, model, url);
            };
            FileUploadDownloadService.prototype.getSecuredDocumentKey = function (docMetadataId) {
                var params = {};
                this.handlerUrl = "./api/document/" + docMetadataId + "/SecuredDocumentKey";
                return this.useGetHandler(params);
            };
            FileUploadDownloadService.prototype.deleteDocument = function (id) {
                var params = {};
                this.handlerUrl = "./api/document/Delete/" + id;
                return this.usePostHandler(params);
            };
            FileUploadDownloadService.prototype.editIsSecure = function (docId, manageDocumentConfigUniqueId, isSecure) {
                var params = {};
                this.handlerUrl = "./api/document/EditIsSecure/" + docId + "/" + manageDocumentConfigUniqueId + "/" + isSecure;
                return this.usePostHandler(params);
            };
            FileUploadDownloadService.prototype.updateDocumentMetadata = function (documents, documentConnections, previousDocumentIds, isTemporary) {
                var params = {
                    documents: documents,
                    documentConnections: documentConnections,
                    previousDocumentIds: previousDocumentIds,
                    isTemporary: isTemporary
                };
                this.handlerUrl = "./api/document/DocumentMetadata/Process/" + documentConnections.processId;
                return this.usePostHandler(params);
            };
            FileUploadDownloadService.prototype.commonUpload = function (files, model, url) {
                var _this = this;
                model.errorMessage = undefined;
                var d = this.$q.defer();
                if (files && files.length) {
                    this.upload.upload({
                        url: url,
                        data: { files: files }
                    }).then(function (response) { _this.$timeout(function () { d.resolve(response.data); }); }, function () {
                        model.errorMessage = _this.errorMsg;
                        model.fileUploadProgress = undefined;
                        d.resolve(undefined);
                    }, function (evt) {
                        model.fileUploadProgress = Math.min(100, 100.0 * (evt.loaded / evt.total));
                    });
                }
                return d.promise;
            };
            return FileUploadDownloadService;
        }(services.HttpHandlerService));
        services.FileUploadDownloadService = FileUploadDownloadService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('FileUploadDownloadService', ['$http', '$q', '$timeout', 'Upload']);
